import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import EditGroup from "src/components/panel/groups/EditGroup";

const EditGroupView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("edit_group_title")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("edit_group_tab")}
          subtitle={t("edit_group_subtitle")}
        />
        <EditGroup />
      </Sidebar>
    </>
  );
};

export default EditGroupView;
